import AuctionBroadcaster from '@/repositories/auction/AuctionBroadcaster.ts';
import { AuctionStatusBroadcast, InProgressAuctionBroadcastItem } from '@/types/auction.type.ts';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function useAuctionBroadcaster() {
    const auctionBroadcaster = new AuctionBroadcaster();

    function listenInProgressAuctions(callback: (auctions: InProgressAuctionBroadcastItem[]) => void): void {
        auctionBroadcaster.listenInProgressAuctions(callback);
    }

    function leaveInProgressAuctions(): void {
        auctionBroadcaster.leaveInProgressAuctions();
    }

    function listenAuctionStatus(callback: (auction: AuctionStatusBroadcast) => void): void {
        auctionBroadcaster.listenAuctionStatus(callback);
    }

    function leaveAuctionStatus(): void {
        auctionBroadcaster.leaveAuctionStatus();
    }

    return {
        listenInProgressAuctions: listenInProgressAuctions,
        leaveInProgressAuctions: leaveInProgressAuctions,
        listenAuctionStatus: listenAuctionStatus,
        leaveAuctionStatus: leaveAuctionStatus,
    };
}
